// Scripting to handle card clicks and links
(function ($) {

	//Stop propagation on linked card anchor clicks
	$(document).on('click', '.is-style-category-card.linked-card a', function (e) {
		e.preventDefault();
	});

	//Capture card clicks outside of the anchors
	$(document).on('click', '.is-style-category-card.linked-card', function (e) {
		// Check if the click was on an anchor element
		let $card = $(this).hasClass('is-style-category-card') ? $(this) : $(this).parents('.is-style-category-card');
		let $anchor = $card.find('a').first();

		if ($anchor.length) {
			handleCardAnchorClick($anchor);
		}
	});

	function handleCardAnchorClick($anchor) {
		//Modals have to trigger a special event to avoid recursive clicking
		if ($anchor.hasClass('open-popup-link')) {
			$anchor.trigger('modalclick');
		} else if ($anchor.attr('target') == '_blank') {
			window.open($anchor.attr('href'));
		} else {
			window.location = $anchor.attr('href');
		}
	}
	
})(jQuery);